var SCROLL_BOTTOM_OFFSET = 500;
var SCROLL_TOP_OFFSET = 100;
/**
 * check if the element is visible in the viewport
 * @param elementRect element to check visibility
 * @returns if element is in viewport
 */
var isElementVisible = function (elementRect) {
    //check the distance from the top of the page
    return elementRect.top <= (window.innerHeight || document.documentElement.clientHeight) - SCROLL_TOP_OFFSET &&
        //check the distance from the bottom of the page
        elementRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + SCROLL_BOTTOM_OFFSET;
};
/**
 * check if the element is visible in the viewport with the offset
 * @param elementRect element to check visibility
 * @returns if element is in viewport
 */
var isElementVisibleWithOffset = function (elementRect, topOffset) {
    //check the distance from the top of the page
    return elementRect.top <= (window.innerHeight || document.documentElement.clientHeight) - topOffset &&
        //check the distance from the bottom of the page
        elementRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + SCROLL_BOTTOM_OFFSET;
};

export { isElementVisible, isElementVisibleWithOffset };
//# sourceMappingURL=visibility.esm.js.map
